"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgAcceptSupervisor = function SvgAcceptSupervisor(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 23"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M.632 5v12M6.947 5v12m5.67-15.882c.808-.06 1.316-.098 1.524-.112 1.149-.087 2.025.566 2.628 1.958.905 2.089 2.273 7.967.397 16.076-.298 1.903-1.46 2.747-2.528 2.618a88.727 88.727 0 0 0-2.067-.225c-.835-.164-1.176-.764-1.024-1.8.227-1.555.177-1.037.387-2.284.21-1.247.319-1.13 1.68-1.74 1.36-.609 1.717-.282 1.728-2.177.007-1.263-.037-2.933-.132-5.01.01-.736-.442-1.172-1.355-1.309-1.37-.206-1.682-.507-2.014-1.944a23.43 23.43 0 0 1-.473-2.757c.025-.802.442-1.234 1.25-1.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m25.621.672.707.707-4.95 4.95-.706-.708zm0 19.656.707-.707-4.95-4.95-.706.708zM21 10h6v1h-6z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgAcceptSupervisor);
var _default = exports["default"] = Memo;